<mat-list class="mat-list-subform">
    <ng-content select="mat-list-item[mgdFormListItem=item]"></ng-content>

    @if (requiredError) {
            <ng-content select="mat-list-item[mgdFormListItem=requiredText]"></ng-content>
    }
    @else {
            <ng-content select="mat-list-item[mgdFormListItem=add]"></ng-content>
    } 
   

</mat-list>
